export const isClient = (() => typeof window !== 'undefined' || typeof document !== 'undefined')();
